import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

export const selectApplicationContacts = createSelector(
  selectLoanApplication,
  ({ contacts }) => contacts.applicationContacts,
);

// with possible duplicates
export const selectAllContacts = createSelector(selectLoanApplication, ({ contacts }) =>
  contacts.applicationContacts.concat(contacts.allContacts),
);

export const selectLookedUpContactValues = createSelector(
  selectLoanApplication,
  ({ contacts }) => contacts.lookedUpValues,
);
